import React, { Component } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    Button,
    Grid,
    MenuItem,
    Collapse,
    Tab,
    Tabs,
    CircularProgress
} from '@mui/material';
import {
    InventoryOutlined as InventoryIcon,
    CollectionsOutlined as CollectionsIcon,
    KeyboardArrowDown as ArrowDownIcon,
    KeyboardArrowUp as ArrowUpIcon,
    Check
} from '@mui/icons-material';
import LayersIcon from '@mui/icons-material/Layers';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { apiUrl } from '../../comp/ApiUrl';
import { WithRouter } from '../../comp/WithRouter';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

class BasicProductEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Controle de edições não salvas e envio
            isDirty: false,
            isSubmitting: false,

            // Bloco de Fotos
            fotos: [],
            categorias: [],

            // Bloco de Informações Básicas
            nome: '',
            descricao: '',
            categoria: '',
            subcategoria: '',
            marca: '',
            sku: '',
            destaque: 0,

            // Controle de interface
            expandidoOpcional: false,
            precoVenda: '',
            precoOriginal: '',
            precoSobConsulta: false,

            // Preço de atacado
            expandidoAtacado: false,
            venderAtacado: true,
            exibirApenasAtacado: false,
            precoAtacado: '',
            qtdMinima: 3,
            unidade: 'UN',

            // Bloco de Variações
            variacoes: [],
        };
        this.fileInputRef = React.createRef();
    }

    componentDidMount() {
        document.title = 'Editar Produto';

        // Escuta o fechar ou recarregar da aba no navegador
        window.addEventListener('beforeunload', this.handleBeforeUnload);

        fetch(`${apiUrl}/produtos/editar/${this.props.params.uuid}`, {
            method: "GET",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
        }).then((response) => {
            if (response.status === 200) {
                response.json().then((data) => {
                    this.setState({
                        nome: data.product.nome || '',
                        descricao: data.product.descricao || '',
                        fotos: data.product.fotos || [],
                        categoria: data.product.categoryId || '',
                        categorias: data.categorias || [],
                        sku: data.product.ean || '',
                        marca: data.product.mark || '',
                        destaque: data.product.emphasis || 0,
                        expandidoOpcional: !!(data.product.ean || data.product.mark || data.product.emphasis),
                        quantidade: data.product.quantidade || 0,
                        precoVenda: data.product.preco || 0,
                        precoOriginal: data.product.custo || 0,
                        variacoes: data.product.variacoes || [],
                        isDirty: false // Garante que o estado inicial após o carregamento seja limpo
                    });
                });
            }
        })
            .catch((error) => {
                console.error("Erro ao buscar produtos", error);
            });
    }

    componentWillUnmount() {
        // Remove o evento ao desmontar o componente para evitar memory leak
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }

    // Alerta nativo do navegador ao recarregar/fechar aba
    handleBeforeUnload = (event) => {
        if (this.state.isDirty) {
            event.preventDefault();
            event.returnValue = ''; // Exigido para que a caixa de alerta apareça em navegadores modernos
        }
    };

    // Intercepta a troca de abas (Links de navegação da SPA)
    handleTabClick = (event) => {
        if (this.state.isDirty) {
            const confirmLeave = window.confirm("Você tem alterações não salvas. Se sair agora, você perderá essas dados. Deseja continuar?");
            if (!confirmLeave) {
                event.preventDefault(); // Impede a transição para outra rota
            }
        }
    };

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({
            [name]: value,
            isDirty: true // Marca o formulário como alterado
        });
    };

    handleSwitchChange = (event) => {
        const { name, checked } = event.target;
        this.setState({
            [name]: checked,
            isDirty: true
        });
    };

    toggleOpcionais = () => {
        this.setState((prevState) => ({ expandidoOpcional: !prevState.expandidoOpcional }));
    };

    handleRemoverFoto = (id) => {
        this.setState((prevState) => {
            const novasFotos = prevState.fotos.filter((foto) => foto.id !== id);
            const tinhaPrincipal = prevState.fotos.find(f => f.id === id)?.principal;
            if (tinhaPrincipal && novasFotos.length > 0) {
                novasFotos[0].principal = true;
            }
            return { fotos: novasFotos, isDirty: true };
        });
    };

    handleFileChange = async (event) => {
        const files = Array.from(event.target.files);
        if (files.length === 0) return;

        const formData = new FormData();
        files.forEach((file) => {
            formData.append("images", file);
        });

        try {
            const toastId = toast.loading("Enviando imagens...");

            const response = await fetch(`${apiUrl}/products/upload-images`, {
                method: "POST",
                credentials: "include",
                body: formData,
            });

            const data = await response.json();

            if (data.success && data.imagens) {
                toast.update(toastId, { render: "Imagens enviadas com sucesso!", type: "success", isLoading: false, autoClose: 3000 });

                this.setState((prevState) => {
                    const novasFotos = data.imagens.map((img, index) => ({
                        id: img.id,
                        name: img.name,
                        url: `${img.name}`,
                        principal: prevState.fotos.length === 0 && index === 0
                    }));
                    return { fotos: [...prevState.fotos, ...novasFotos], isDirty: true };
                });
            } else {
                toast.update(toastId, { render: data.error || "Erro ao subir imagens.", type: "error", isLoading: false, autoClose: 3000 });
            }
        } catch (error) {
            console.error("Erro no upload de fotos:", error);
            toast.error("Erro de conexão ao enviar imagens.");
        }

        event.target.value = '';
    };

    triggerFileSelect = () => {
        this.fileInputRef.current.click();
    };

    handleSalvar = async () => {
        const { nome, descricao, categoria, sku, marca, destaque, isSubmitting } = this.state;

        if (isSubmitting) return;

        if (!nome || !nome.trim()) {
            toast.warning("O nome do produto é obrigatório.");
            return;
        }

        this.setState({ isSubmitting: true });

        try {
            const response = await fetch(`${apiUrl}/products/set/v2/basic`, {
                method: "PUT",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    uuid: this.props.params.uuid,
                    nome: nome.trim(),
                    descricao,
                    categoria,
                    sku,
                    marca,
                    destaque,
                }),
            });

            const data = await response.json();

            if (data.success) {
                toast.success("Produto atualizado com sucesso!");
                this.setState({ isDirty: false }); // Limpa o estado de alteração após salvar com sucesso
            } else {
                toast.error(data.message || "Erro ao atualizar produto.");
            }
        } catch (error) {
            console.error("Erro ao atualizar produto:", error);
            toast.error("Erro de conexão com o servidor.");
        } finally {
            this.setState({ isSubmitting: false });
        }
    };

    render() {
        const {
            nome,
            descricao,
            categoria,
            categorias,
            marca,
            sku,
            destaque,
            expandidoOpcional,
            isSubmitting,
            isDirty
        } = this.state;

        const inputStyle = {
            '& .MuiOutlinedInput-root': {
                backgroundColor: '#f8fafc',
                borderRadius: 2,
                '& fieldset': { borderColor: '#e2e8f0' },
                '&:hover fieldset': { borderColor: '#cbd5e1' },
                '&.Mui-focused fieldset': { borderColor: '#9966f1' }
            },
            '& .MuiOutlinedInput-input::placeholder': {
                color: '#94a3b8',
                opacity: 1
            }
        };

        return (
            <Box sx={{ p: 0, backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                <input
                    type="file"
                    multiple
                    accept="image/*"
                    ref={this.fileInputRef}
                    style={{ display: 'none' }}
                    onChange={this.handleFileChange}
                />

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 4 }}>
                    <Box>
                        <Typography variant="h5" fontWeight="700" gutterBottom>
                            Editar Produto {isDirty && <span style={{ color: '#eab308', fontSize: '0.8rem' }}>(Alterações não salvas)</span>}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Edite as informações do produto
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Button
                            variant="contained"
                            onClick={this.handleSalvar}
                            disabled={isSubmitting}
                            startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : <Check />}
                            sx={{
                                borderRadius: '8px',
                                textTransform: 'none',
                            }}
                        >
                            {isSubmitting ? 'Salvando...' : 'Salvar'}
                        </Button>
                    </Box>
                </Box>

                {/* Tabs */}
                <Box sx={{ mb: 4 }}>
                    <Tabs
                        value={0}
                        variant="scrollable"
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        sx={{
                            '& .MuiTabs-indicator': { display: 'none' },
                            '& .MuiTabs-scroller': {
                                overflowX: 'auto',
                            },
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                minHeight: '40px',
                                borderRadius: '8px',
                                mr: 1,
                                fontWeight: 500,
                                color: '#666',
                                whiteSpace: 'nowrap',
                                flexShrink: 0
                            },
                            '& .Mui-selected': {
                                bgcolor: '#fff',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                color: '#000 !important'
                            }
                        }}
                    >
                        <Tab
                            component={Link}
                            to={`/produtos/${this.props.params.uuid}/basic`}
                            onClick={this.handleTabClick}
                            icon={<InventoryIcon sx={{ color: '#9c27b0' }} />}
                            iconPosition="start"
                            label="Informações Básicas"
                        />
                        <Tab
                            component={Link}
                            to={`/produtos/${this.props.params.uuid}/photos`}
                            onClick={this.handleTabClick}
                            icon={<CollectionsIcon sx={{ color: '#9c27b0' }} />}
                            iconPosition="start"
                            label="Fotos do Produto"
                        />
                        <Tab
                            component={Link}
                            to={`/produtos/${this.props.params.uuid}/price`}
                            onClick={this.handleTabClick}
                            icon={<AttachMoneyIcon sx={{ color: '#9c27b0' }} />}
                            iconPosition="start"
                            label="Preço"
                        />
                        <Tab
                            component={Link}
                            to={`/produtos/${this.props.params.uuid}/attributes`}
                            onClick={this.handleTabClick}
                            icon={<LayersIcon sx={{ color: '#9c27b0' }} />}
                            iconPosition="start"
                            label="Atributos & Variações"
                        />
                    </Tabs>
                </Box>

                {/* INFORMAÇÕES BÁSICAS */}
                <Card sx={{ borderRadius: 3, boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.04)', border: '1px solid #e2e8f0' }}>
                    <CardContent sx={{ p: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                            <Box sx={{ bgcolor: '#f3e5f5', p: 1, borderRadius: 2, display: 'flex' }}>
                                <InventoryIcon sx={{ color: '#9c27b0' }} />
                            </Box>
                        </Box>

                        {/* Campo: Nome do produto */}
                        <Box sx={{ mb: 2.5 }}>
                            <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                Nome do produto <span style={{ color: '#ef4444' }}>*</span>
                            </Typography>
                            <TextField
                                fullWidth
                                name="nome"
                                value={nome}
                                onChange={this.handleInputChange}
                                placeholder="Ex: Vestido Floral Primavera"
                                variant="outlined"
                                size="small"
                                sx={inputStyle}
                            />
                        </Box>

                        {/* Campo: Descrição */}
                        <Box sx={{ mb: 2.5 }}>
                            <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                Descrição
                            </Typography>
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                name="descricao"
                                value={descricao}
                                onChange={this.handleInputChange}
                                placeholder="Escreva os detalhes, tecido, medidas..."
                                variant="outlined"
                                size="small"
                                inputProps={{ maxLength: 1500 }}
                                sx={inputStyle}
                            />
                            <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.5 }}>
                                {descricao.length}/1500
                            </Typography>
                        </Box>

                        {/* Grid: Categoria */}
                        <Grid container spacing={2} sx={{ mb: 3 }}>
                            <Grid item size={{ xs: 12, md: 2 }}>
                                <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                    Categoria
                                </Typography>
                                <TextField
                                    select
                                    fullWidth
                                    name="categoria"
                                    value={categoria}
                                    onChange={this.handleInputChange}
                                    variant="outlined"
                                    size="small"
                                    displayEmpty
                                    sx={inputStyle}
                                >
                                    {categorias.map((cat) => (
                                        <MenuItem key={cat.id} value={cat.id}>{cat.nome}</MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                        </Grid>

                        {/* Seletor Desdobrável: Marca, código e destaque */}
                        <Box sx={{ mb: 1 }}>
                            <Button
                                onClick={this.toggleOpcionais}
                                startIcon={expandidoOpcional ? <ArrowUpIcon fontSize="small" /> : <ArrowDownIcon fontSize="small" />}
                                sx={{
                                    textTransform: 'none',
                                    color: '#64748b',
                                    fontWeight: '500',
                                    fontSize: '0.875rem',
                                    p: 0,
                                    '&:hover': { bgcolor: 'transparent', color: '#475569' }
                                }}
                            >
                                Marca, código e destaque (opcional)
                            </Button>
                        </Box>

                        <Collapse in={expandidoOpcional}>
                            <Grid container spacing={2} sx={{ mt: 0.5 }}>
                                {/* Campo: Marca */}
                                <Grid item xs={12} sm={4}>
                                    <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                        Marca
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        name="marca"
                                        value={marca}
                                        onChange={this.handleInputChange}
                                        placeholder="Ex: Nike"
                                        variant="outlined"
                                        size="small"
                                        sx={inputStyle}
                                    />
                                </Grid>

                                {/* Campo: Código/SKU */}
                                <Grid item xs={12} sm={4}>
                                    <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                        Código/SKU
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        name="sku"
                                        value={sku}
                                        onChange={this.handleInputChange}
                                        placeholder="Ex: SKU-123"
                                        variant="outlined"
                                        size="small"
                                        sx={inputStyle}
                                    />
                                </Grid>

                                {/* Campo: Destaque */}
                                <Grid item xs={12} sm={4}>
                                    <Typography variant="body2" sx={{ fontWeight: '600', mb: 1, color: '#1e293b' }}>
                                        Destaque
                                    </Typography>
                                    <TextField
                                        select
                                        fullWidth
                                        name="destaque"
                                        value={destaque}
                                        onChange={this.handleInputChange}
                                        variant="outlined"
                                        size="small"
                                        sx={inputStyle}
                                    >
                                        <MenuItem value="0">Nenhum</MenuItem>
                                        <MenuItem value="1">Novidade</MenuItem>
                                        <MenuItem value="2">Promoção</MenuItem>
                                        <MenuItem value="3">Mais Vendido</MenuItem>
                                        <MenuItem value="4">Últimas Unidades</MenuItem>
                                    </TextField>
                                </Grid>
                            </Grid>
                        </Collapse>
                    </CardContent>
                </Card>
            </Box>
        );
    }
}

export default WithRouter(BasicProductEdit);